import moment from "moment-timezone";
import { RADatePicker, RATimePicker, RATypography } from "@/components/customs";
import { Row, Col, Grid } from "antd";
import { SvgCalendar, SvgTime } from "@/assets/icons";
import { RAInputTimePickerMobile } from "@/components/atoms";
import { useEffect, useState } from "react";

const { useBreakpoint } = Grid;

export function InputDateInquiry({ departure_datetime, onChange, error = {}, disabledFromDate, disabled = false }) {
	const screens = useBreakpoint();
	const [isTouchScreen, setIsTouchScreen] = useState(false);
	useEffect(() => {
		if ("ontouchstart" in window || navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0) {
			setIsTouchScreen(true);
		}
	}, []);
	if (!screens.xs) {
		return (
			<Row gutter={0}>
				<Col span={24}>
					<RADatePicker
						prefix={<SvgCalendar color="#595959" />}
						placeholder="Departure date"
						value={departure_datetime || null}
						showTime
						disabledFromDate={disabledFromDate}
						disabled={disabled}
						onSelect={(val) => {
							let value = val;
							if (!departure_datetime) {
								value = moment(val).set({ hour: 0, minute: 0 }).toISOString();
							}
							onChange(value);
						}}
						error={error?.departureDatetime}
						data-testid="sendInquiry_departureDate"
					/>
				</Col>
			</Row>
		);
	}
	// mobile view: date + time
	return (
		<Row gutter={[8, 8]}>
			<Col span={12}>
				<RADatePicker
					prefix={<SvgCalendar color="#595959" />}
					placeholder="Date"
					value={departure_datetime || null}
					disabledFromDate={disabledFromDate}
					disabled={disabled}
					format="ddd, MMM DD"
					onChange={(val) => {
						let value = val;
						if (!departure_datetime) {
							value = moment(val).set({ hour: 0, minute: 0 }).toISOString();
						}
						onChange(value);
					}}
				/>
			</Col>
			<Col span={12}>
				{isTouchScreen ? (
					<RAInputTimePickerMobile
						prefix={<SvgTime color="#595959" />}
						value={departure_datetime || null}
						disabled={disabled}
						onChange={(val) => {
							let date = departure_datetime ? moment(departure_datetime) : moment();
							let time = moment(val);
							date = moment(date).set({
								hour: time.get("hour"),
								minute: time.get("minute"),
							});
							onChange(date.toISOString());
						}}
					/>
				) : (
					<RATimePicker
						prefix={<SvgTime color="#595959" />}
						placeholder="Time"
						value={departure_datetime || null}
						disabledFromDate={disabledFromDate}
						dropdownAlign={{ offset: [-44, 4] }}
						disabled={disabled}
						onChange={(val) => {
							let date = departure_datetime ? moment(departure_datetime) : moment();
							let time = moment(val);
							date = moment(date).set({
								hour: time.get("hour"),
								minute: time.get("minute"),
							});
							onChange(date.toISOString());
						}}
					/>
				)}
			</Col>
			<Col span={24}>
				{!!error?.departureDatetime && (
					<RATypography variant="body3" color="#BF1A2F" top="4px">
						{error?.departureDatetime}
					</RATypography>
				)}
			</Col>
		</Row>
	);
}
